<div>
  <div id="mySideNav" class="sidenav">
    <div class="top-sidenav">
      <a (click)="angulartics2Track('VervendoLogoClickBurger')" href="#" class="logo"></a>
      <a>
        <svg (click)="closeNavHome()" id="close-icon" data-name="Close Icon" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 34.83 34.83">
          <defs>
            <style>
              .close-gray {
                fill: none;
                stroke: #818181;
                stroke-miterlimit: 10;
                stroke-width: 4px
              }
            </style>
          </defs>
          <path class="close-gray" d="M1.41 1.41l32 32" />
          <path class="close-gray" d="M33.41 1.41l-32 32" />
        </svg>
      </a>
    </div>

    <div class="divider-horizontal--light-gray"></div>

    <div class="bottom-sidenav flex-col ai-c">
      <a href="#" (click)="closeNavHome(); angulartics2Track('HomeBurger')">Home</a>
      <a routerLink="about-us" (click)="closeNavHome(); angulartics2Track('AboutBurger')">About</a>
      <a routerLink="contact-us" (click)="closeNavHome(); angulartics2Track('ContactUsBurger')">Contact Us</a>
    </div>

    <div class="divider-horizontal--light-gray"></div>

    <div class="flex jc-c w-100" *ngIf="!userlogged" (click)="burgerLogIn()">
      <button class="sidenav__login">
        Log in
      </button>
    </div>

    <div class="flex-col jc-c ai-c gap-1 w-100" *ngIf="isMobile() && userlogged">
      <a class="sidenav__create" (click)="goToNewSearch(); angulartics2Track('NewRequestBurger')">
        Create New Request
      </a>

      <a (click)="logout()" class="sidenav__logout">
        Logout
      </a>
    </div>

  </div>
  <header *ngIf="!inBookingPath" id="home-header" class="apps-header">
    <nav class="nav flex jc-sb ai-c">
      <a href="#">
        <img class="nav__logo" src="../../../../assets/img/icons/vervendo-logo_horizontal_blue.svg" alt="Vervendo Blue Logo" (click)="angulartics2Track('VervendoLogoClickDesktop')">
        <img class="nav__logo--mobile" src="../../../../assets/img/icons/vervendo_logo-symbol.svg" alt="Vervendo Blue Logo Symbol" (click)="angulartics2Track('VervendoLogoClickDesktop')">
      </a>
      <div class="flex ai-c gap-1">
        <app-right-navigation [userlogged]="userlogged" [userInfo]="userInfo" [unreadMessages]="unreadMessages"
          [activeOffers]="activeOffers" [isHome]="true" (logout)="logout($event)"
          (openLoginModal)="openLoginModal($event)">
        </app-right-navigation>
        <span class="left-navigation-toggler" (click)="openNavHome()">&#9776;</span>
      </div>
    </nav>


    <!-- ΤO-DO: REMOVE AND REDESIGN BACK BUTTON -->
    <!-- <div id="headerSorting" class="row header-single" *ngIf="headerType === 'SingleHotel'">
      <div class="col-6 hotel-title-info">
        <h1 *ngIf="hotelInfo">
          <span>{{hotelInfo.title}}</span>
        </h1>
      </div>
      <div class="col-6 single-hotel-back">
        <div class="backBtn float-right">
          <a (click)="goBack()">Back to my offers</a>
        </div>
      </div>
    </div> -->

    <app-login-view #loginModal (modalClosed)="modalClosed($event)"></app-login-view>
  </header>
</div>